export { default as Carousel } from './Carousel';
export type { CarouselProps } from './Carousel';
